<template>
    <div class="z-10">
        <PageComponent 
            :loader="loader" @showLoader="showLoader" @hideLoader="hideLoader"
            :addButtonLabel="addButtonLabel"
            @handleAddNew="addNewOpportunity"
            :searchFilters="searchFilters"
            :dropdownOptions="dropdownOptions"
            @handleDynamicOption="handleDynamicOption"
            @searchPage="searchOpportunities"
            @resetFilters="resetFilters"
            @importData="importLeads"
            @removeItem="removeOpportunity"
            @removeSelectedItems="removeOpportunitys"
            @printList="printCustomersList"
            :addingRight="addingRight"
            :removingRight="removingRight"
            :rightsModule="rightsModule"
            :columns="tableColumns"
            :rows="oppsList"
            :actions="actions"
            :idField="idField"
            @handleSelectionChange="handleSelectionChange"
            @handleActionClick="handleActionClick"
            :count="propCount"
            :currentPage="currentPage"
            :result="propArrLen"
            @loadPrev="loadPrev"
            @loadNext="loadNext"
            @firstPage="firstPage"
            @lastPage="lastPage"
            :showNextBtn="showNextBtn"
            :showPreviousBtn="showPreviousBtn"
            :selectedValue="selectedValue"
            @selectSearchQuantity="selectSearchQuantity"
        />
        <MovableModal v-model:visible="propModalVisible" :title="title" :modal_top="modal_top" :modal_left="modal_left" :modal_width="modal_width"
            :loader="modal_loader" @showLoader="showModalLoader" @hideLoader="hideModalLoader" @closeModal="closeModal">
            <DynamicForm 
                :fields="formFields" :flex_basis="flex_basis" :flex_basis_percentage="flex_basis_percentage" 
                :displayButtons="displayButtons" @handleSubmit="saveOpportunity" @handleReset="handleReset"
            />
        </MovableModal>
        <MovableModal v-model:visible="transModalVisible" :title="title1" :modal_top="modal_top" :modal_left="modal_left" :modal_width="modal_width"
            :loader="modal_loader1" @showLoader="showModalLoader1" @hideLoader="hideModalLoader1"  @closeModal="closeModal1">
            <div class="px-3">
                <div class="basis-1/4 mr-8 relative">
                    <label for="">System SMS Templates:<em></em></label><br />
                    <SearchableDropdown
                        :options="templateArr"
                        :dropdownWidth="dropdownWidth"
                        @option-selected="handleSelectedTemplate"
                        @clearSearch="clearSelectedTemplate"                               
                    />
                </div>
                <div class="text-left mb-4">
                    <label for="">Message:</label><br />
                    <!-- <quill-editor :key="editorComponentKey" v-model:value="messageContent"></quill-editor> -->

                    <div class="flex">
                        <div class="basis-1/2 mb-4 mr-3">
                            <select v-model="selectedPlaceholder" class="bg-slate-50 rounded border border-gray-400 text-sm pl-2 pt-1 w-full">
                                <option value="" disabled>Select Placeholder</option>
                                <option v-for="placeholder in leadPlaceholders" :key="placeholder.value" :value="placeholder.value">
                                    {{ placeholder.label }}
                                </option>
                            </select>
                        </div>
                        <button @click="insertPlaceholder" :disabled="!selectedPlaceholder" class="w-24 h-8 rounded bg-green-400 text-sm mr-2  text-white px-2 py-0.5">Insert</button>
                    </div>

                    <textarea v-model="contentModel" ref="textareaRef" rows="8" cols="64" class="bg-slate-50 rounded border border-gray-400 text-sm pl-2 pt-2" placeholder="Type your content here..."></textarea>
                </div>
                <button @click="sendClientSMS" class="rounded bg-green-400 text-sm mr-2  text-white px-2 py-1.5"><i class="fa fa-check-circle text-xs mr-1.5" aria-hidden="true"></i>Send SMS</button>
            </div>
        </MovableModal>
        <MovableModal v-model:visible="emailModalVisible" :title="title2" :modal_top="modal_top" :modal_left="modal_left" :modal_width="modal_width"
            :loader="modal_loader1" @showLoader="showModalLoader1" @hideLoader="hideModalLoader1"  @closeModal="closeModal1">
            <div class="px-3">
                <div class="basis-1/4 mr-8 relative mb-4">
                    <label for="">System Email Templates:<em></em></label><br />
                    <SearchableDropdown
                        :options="emailTempArr"
                        :dropdownWidth="dropdownWidth"
                        @option-selected="handleSelectedEmailTemplate"
                        @clearSearch="clearSelectedEmailTemplate"                               
                    />
                </div>
                <button @click="sendClientEmail" class="rounded bg-green-400 text-sm mr-2  text-white px-2 py-1.5"><i class="fa fa-check-circle text-xs mr-1.5" aria-hidden="true"></i>Send Email</button>
            </div>
        </MovableModal>
    </div>
</template>

<script>
import axios from "axios";
import { ref, computed, onMounted, onBeforeMount, watch} from 'vue';
import PageComponent from '@/components/PageComponent.vue';
import SearchableDropdown from "@/components/SearchableDropdown.vue";
import MovableModal from '@/components/MovableModal.vue'
import DynamicForm from '../NewDynamicForm.vue';
import { useStore } from "vuex";
import { useToast } from "vue-toastification";
import { quillEditor } from 'vue3-quill';
import { useTextareaEditor } from '@/composables/TextAreaEditor';
import Swal from 'sweetalert2';

export default{
    name: 'Opportunities',
    components:{
        PageComponent, MovableModal,DynamicForm,quillEditor,SearchableDropdown
    },
    setup(){
        const { contentModel,textareaRef,leadPlaceholders,selectedPlaceholder,insertPlaceholder,} = useTextareaEditor('');
        const templateArr = computed(() => store.state.Crm_SMS_Templates.templateArr);
        const emailTempArr = computed(() => store.state.Crm_Email_Templates.templateArr);
        const emailTempID = ref('');
        const dropdownWidth = ref("500px");
        const messageContent = ref('');
        const modal_loader1 = ref('none');
        const title1 = ref('SMS Opportunity(s)');
        const title2 = ref('Email Opportunity(s)');
        const transModalVisible = ref(false);
        const emailModalVisible = ref(false);
        const currComponentKey = ref(0);
        const leadID = ref('');
        const opportunityID = ref(null);
        const store = useStore();     
        const toast = useToast();
        const loader = ref('none');
        const modal_loader = ref('none');
        const idField = 'opportunity_id';
        const addButtonLabel = ref('New Opportunity');
        const title = ref('Opportunity Details');
        const addingRight = ref('Adding Marketing Opportunities');
        const removingRight = ref('Deleting Marketing Opportunities');
        const rightsModule = ref('CRM');
        const submitButtonLabel = ref('Add');
        const selectedIds = ref([]);
        const oppsList = ref([]);
        const propResults = ref([]);
        const propArrLen = ref(0);
        const propCount = ref(0);
        const pageCount = ref(0);
        const selectedValue = ref(50);
        const currentPage = ref(1);
        const showNextBtn = ref(false);
        const showPreviousBtn = ref(false);
        const propModalVisible = ref(false);
        const flex_basis = ref('');
        const flex_basis_percentage = ref('');
        const displayButtons = ref(true);
        const errors = ref([]);
        const modal_top = ref('150px');
        const modal_left = ref('400px');
        const modal_width = ref('45vw');
        const isEditing = computed(()=> store.state.Opportunities.isEditing);
        const selectedOpportunity = computed(()=> store.state.Opportunities.selectedOpportunity);
        const selectedLead = computed(()=> store.state.Opportunities.selectedLead);
        const leadArray = computed(() => store.state.Sales_Leads.leadArr);
        const showModal = ref(false);
        const tableColumns = ref([
            {type: "checkbox"},
            {label: "Name", key:"name"},
            {label: "Value", key:"value"},
            {label: "Probability", key: "probability"},
            {label: "Expect. Close Date", key:"expected_close_date"},
            {label: "Stage", key:"stage", textColor: "stageColor"},
            {label: "Notes", key:"notes"},
        ])
        const actions = ref([
            {name: 'edit', icon: 'fa fa-edit', title: 'Edit Opportunity', rightName: 'Editing Marketing Opportunities'},
            {name: 'send-sms', icon: 'fas fa-comment', title: 'Send SMS', rightName: 'Sending CRM SMS'},
            {name: 'send-email', icon: 'fas fa-envelope', title: 'Send Email', rightName: 'Sending CRM Emails'},
            {name: 'convert', icon: 'fa fa-sign-in', title: 'Convert Opportunity', rightName: 'Converting Marketing Leads'},
            {name: 'delete', icon: 'fa fa-trash', title: 'Delete Opportunity', rightName: 'Deleting Marketing Opportunities'},
        ])
        const companyID = computed(()=> store.state.userData.company_id);
        const userID = computed(()=> store.state.userData.user_id);
        const stage_search = ref("");
        const lead_name_search = ref("");
        const searchFilters = ref([
            {type:'text', placeholder:"Name...", value: lead_name_search, width:48,},
            {
                type:'dropdown', placeholder:"Stage..", value: stage_search, width:28,
                options: [{text:'Open',value:'Open'},{text:'Qualified',value:'Qualified'},{text:'Proposal Sent',value:'Proposal Sent'},{text:'Negotiation',value:'Negotiation'},{text:'Closed Won',value:'Closed Won'},{text:'Closed Lost',value:'Closed Lost'}]
            },

        ]);
        const handleSelectionChange = (ids) => {
            selectedIds.value = ids;
        };
        const fetchMarketingLeads = async() =>{
            await store.dispatch('Sales_Leads/fetchMarketingLeads', {company:companyID.value})
        };
        const handleSelectedLead = async(option) =>{
            await store.dispatch('Sales_Leads/handleSelectedLead', option)
            leadID.value = store.state.Sales_Leads.leadID;
            if(selectedOpportunity.value && selectedLead.value){
                selectedOpportunity.value.lead.lead_id = leadID.value;
            }
        }
        const clearSelectedLead = async() =>{
            await store.dispatch('Sales_Leads/updateState', {leadID: ''});
            leadID.value = store.state.Sales_Leads.leadID;
            if(selectedOpportunity.value && selectedLead.value){
                selectedOpportunity.value.lead.lead_id = leadID.value;
            }
        }
        const leadValue = computed(() => {
           return (selectedOpportunity.value && selectedOpportunity.value.lead && !leadID.value) ? selectedOpportunity.value.lead.lead_id : leadID.value;
        });
        const formFields = ref([]);
        const updateFormFields = () => {
            formFields.value = [
                {  
                    type:'search-dropdown', label:"Leads", value: leadValue.value, componentKey: currComponentKey,
                    selectOptions: leadArray, optionSelected: handleSelectedLead, required: true,
                    searchPlaceholder: 'Select Lead...', dropdownWidth: '350px', updateValue: selectedLead.value,
                    clearSearch: clearSelectedLead
                },
                { type: 'text', name: 'name',label: "Name", value: selectedOpportunity.value?.name || '', required: true },
                { type: 'number', name: 'value',label: "Expected Value", value: selectedOpportunity.value?.value || 0, required: false },
                { type: 'number', name: 'probability',label: "Probability (%)", value: selectedOpportunity.value?.probability || 0, required: false },
                { type: 'date', name: 'date',label: "Expected Close Date", value: selectedOpportunity.value?.date || null, required: false },
                { type: 'dropdown', name: 'stage',label: "Stage", value: selectedOpportunity.value?.stage || 'Open', required: true , options: [{text:'Open',value:'Open'},{text:'Qualified',value:'Qualified'},{text:'Proposal Sent',value:'Proposal Sent'},{text:'Negotiation',value:'Negotiation'},{text:'Closed Won',value:'Closed Won'},{text:'Closed Lost',value:'Closed Lost'}]},
                { type: 'text-area', name: 'notes',label: "Notes", value: selectedOpportunity.value?.notes || '', textarea_rows: '3', textarea_cols: '56', required: false },
                
            ];
        };
        const handleReset = () =>{
            for(let i=0; i < formFields.value.length; i++){
                formFields.value[i].value = '';
            }
            formFields.value[2].value = 0;
            formFields.value[3].value = 0;
            formFields.value[4].value = null;
            formFields.value[5].value = 'Open';
        }

        watch([selectedOpportunity, selectedLead], () => {
            if (selectedOpportunity.value && selectedLead.value) {
                updateFormFields();
                currComponentKey.value += 1;
            }
            else if (selectedOpportunity.value) {
                updateFormFields();      
            }
            
        }, { immediate: true });
        
        const showModalLoader = () =>{
            modal_loader.value = "block";
        }
        const hideModalLoader = () =>{
            modal_loader.value = "none";
        }
        const createOpportunity = async() =>{
            showModalLoader();
            let formData = {
                name: formFields.value[1].value,
                value: formFields.value[2].value,
                stage: formFields.value[5].value,
                probability: formFields.value[3].value,
                expected_close_date: formFields.value[4].value,
                notes: formFields.value[6].value,
                lead: leadID.value,
                lead_id: leadID.value,
                company: companyID.value
            }
  
            errors.value = [];
            for(let i=1; i < formFields.value.length; i++){
                if(formFields.value[i].value =='' && formFields.value[i].required == true && formFields.value[i].type != 'search-dropdown'){
                    errors.value.push(formFields.value[i].label);
                }
            }

            if(errors.value.length){
                toast.error('Fill In Required Fields');
                hideModalLoader();
            }else{
                try {
                    const response = await store.dispatch('Opportunities/createMarketingOpportunity', formData);
                    if (response && response.status === 201) {
                        hideModalLoader();
                        toast.success('Opportunity created successfully!');
                        handleReset();
                    } else {
                        toast.error('An error occurred while creating the Opportunity.');
                    }
                } catch (error) {
                    console.error(error.message);
                    toast.error('Failed to create Opportunity: ' + error.message);
                } finally {
                    hideModalLoader();
                    searchOpportunities();
                }
            }
        }
        const updateOpportunity = async() =>{
            showModalLoader();
            errors.value = [];
            let formData = {
                opportunity: selectedOpportunity.value.opportunity_id,
                name: formFields.value[1].value,
                value: formFields.value[2].value,
                stage: formFields.value[5].value,
                probability: formFields.value[3].value,
                expected_close_date: formFields.value[4].value,
                notes: formFields.value[6].value,
                lead_source: leadValue.value,
                lead_source_id: leadValue.value,
                company: companyID.value
            }

            if(errors.value.length){
                toast.error('Fill In Required Fields');
                hideModalLoader();
            }else{
                try {
                    const response = await store.dispatch('Opportunities/updateMarketingOpportunity', formData);
                    if (response && response.status === 200) {
                        hideModalLoader();
                        handleReset();
                        toast.success("Opportunity updated successfully!");              
                    } else {
                        toast.error('An error occurred while updating the Opportunity.');
                    }
                } catch (error) {
                    console.error(error.message);
                    toast.error('Failed to update Opportunity: ' + error.message);
                } finally {
                    hideModalLoader();
                    propModalVisible.value = false;
                    await store.dispatch("Opportunities/updateState",{selectedOpportunity:null,selectedLead:null, isEditing:false})
                    searchOpportunities();
                }             
            }
        }
        const saveOpportunity = () =>{
            if(isEditing.value == true){
                updateOpportunity();
            }else{
                createOpportunity();
            }
        }
        const importLeads = () =>{
            
        }
        const removeOpportunity = async() =>{
            if(selectedIds.value.length == 1){
                let formData = {
                    company: companyID.value,
                    opportunity: selectedIds.value
                }
                try{
                    const response = await store.dispatch('Opportunities/deleteMarketingOpportunity',formData)
                    if(response && response.status == 200){
                        toast.success("Opportunity Removed Succesfully");
                        searchOpportunities();
                    }
                }
                catch(error){
                    console.error(error.message);
                    toast.error('Failed to remove Opportunity: ' + error.message);
                }
                finally{
                    selectedIds.value = [];
                }
            }else if(selectedIds.value.length > 1){
                toast.error("You have selected more than 1 Opportunity") 
            }else{
                toast.error("Please Select An Opportunity To Remove")
            }
        }
        const removeOpportunitys = async() =>{
            if(selectedIds.value.length){
                let formData = {
                    company: companyID.value,
                    opportunity: selectedIds.value
                }
                try{
                    const response = await store.dispatch('Opportunities/deleteMarketingOpportunity',formData)
                    if(response && response.status == 200){
                        toast.success("Opportunity(s) Removed Succesfully");
                        searchOpportunities();
                    }
                }
                catch(error){
                    console.error(error.message);
                    toast.error('Failed to remove Opportunity: ' + error.message);
                }
                finally{
                    selectedIds.value = [];

                }
            }else{
                toast.error("Please Select An Opportunity To Remove")
            }
        }
        const showLoader = () =>{
            loader.value = "block";
        }
        const hideLoader = () =>{
            loader.value = "none";
        }
        const searchOpportunities = () =>{
            showLoader();
            showNextBtn.value = false;
            selectedIds.value = [];
            showPreviousBtn.value = false;
            let formData = {
                name: lead_name_search.value,
                stage: stage_search.value,
                company_id: companyID.value,
                page_size: selectedValue.value
            } 
            axios
            .post(`api/v1/lead-opportunities-search/?page=${currentPage.value}`,formData)
            .then((response)=>{
                oppsList.value = response.data.results;
                store.commit('Opportunities/LIST_OPPORTUNITIES', oppsList.value)
                propResults.value = response.data;
                propArrLen.value = oppsList.value.length;
                propCount.value = propResults.value.count;
                pageCount.value = Math.ceil(propCount.value / selectedValue.value);
                if(response.data.next){
                    showNextBtn.value = true;
                }
                if(response.data.previous){
                    showPreviousBtn.value = true;
                }
            })
            .catch((error)=>{
                console.log(error.message);
            })
            .finally(()=>{
                hideLoader();
            })
        };
        const selectSearchQuantity = (newValue) =>{
            selectedValue.value = newValue;
            searchOpportunities(selectedValue.value);
        };
        const resetFilters = () =>{
            currentPage.value = 1;
            stage_search.value = "";
            lead_name_search.value = "";
            searchOpportunities();
        }
        const loadPrev = () =>{
            if (currentPage.value <= 1){
                currentPage.value = 1;
            }else{
                currentPage.value -= 1;
            }
            
            searchOpportunities();
            // scrollToTop();
        }
        const loadNext = () =>{
            if(currentPage.value >= pageCount.value){
                currentPage.value = pageCount.value;
            }else if(currentPage.value < pageCount.value){
                currentPage.value += 1;
            }
            
            searchOpportunities();
            // scrollToTop(); 
        }
        const firstPage = ()=>{
            currentPage.value = 1;
            searchOpportunities();
            // scrollToTop();
        }
        const lastPage = () =>{
            currentPage.value = pageCount.value;
            searchOpportunities();
            // scrollToTop();
        }
        const addNewOpportunity = async() =>{
            updateFormFields();
            await store.dispatch("Opportunities/updateState",{selectedOpportunity:null,selectedLead:null, isEditing:false})
            propModalVisible.value = true;
            handleReset();
            flex_basis.value = '1/4';
            flex_basis_percentage.value = '25';
            currComponentKey.value += 1;
        }
        const handleActionClick = async(rowIndex, action, row) =>{
            if( action == 'edit'){
                const opportunityID = row[idField];
                let formData = {
                    company: companyID.value,
                    opportunity: opportunityID
                }
                await store.dispatch('Opportunities/fetchMarketingOpportunity',formData)
                propModalVisible.value = true;
                flex_basis.value = '1/4';
                flex_basis_percentage.value = '25';

            }else if(action == 'send-sms'){
                fetchTemplates();
                opportunityID.value = [row[idField]];
                transModalVisible.value = true;
                
            }else if(action == 'send-email'){
                fetchEmailTemplates();
                opportunityID.value = [row[idField]];
                emailModalVisible.value = true;
            }else if(action == "convert"){
                const newOpportunity = row[idField];   
                const opportunityStatus = row['stage'];
                if(opportunityStatus == 'Closed Won'){
                    Swal.fire("Opportunity Already Converted!", {
                        icon: "warning",
                    });
                    return;
                }
                if(opportunityStatus == 'ClosedLost'){
                    Swal.fire("Cannot Convert A Lost Opportunity!", {
                        icon: "warning",
                    });
                    return;
                }
                let formData = {
                    opportunity: newOpportunity,
                    company: companyID.value,
                    user: userID.value
                }
                Swal.fire({
                    title: "Are you sure?",
                    text: `Do you wish to Convert Opportunity?`,
                    type: 'warning',
                    showCloseButton: true,
                    showCancelButton: true,
                    confirmButtonText: 'Yes, Convert!',
                    cancelButtonText: 'Cancel!',
                    customClass: {
                        confirmButton: 'swal2-confirm-custom',
                        cancelButton: 'swal2-cancel-custom',
                    },
                    showLoaderOnConfirm: true,
                    }).then((result) => {
                    if (result.value) {
                        axios.post(`api/v1/converting-marketing-opportunity/`,formData)
                        .then((response)=>{
                        if(response.data.msg == 'Success'){
                            Swal.fire("Opportunity Converted Succesfully!", {
                                icon: "success",
                            });
                            searchOpportunities(); 
                        }else if(response.data.msg == 'Failed'){
                            Swal.fire("Opportunity Already Converted!", {
                                icon: "warning",
                            });
                        }
                        else{
                            Swal.fire({
                                title: "Error Converting Opportunity",
                                icon: "warning",
                            });
                        }                   
                        })
                        .catch((error)=>{
                            console.log(error.message);
                            Swal.fire({
                                title: error.message,
                                icon: "warning",
                            });
                        })
                    }else{
                        Swal.fire(`Opportunity has not been converted!`);
                        searchOpportunities(); 
                    }
                })
                
            }else if(action == 'delete'){
                const opportunityID = [row[idField]];
                let formData = {
                    company: companyID.value,
                    opportunity: opportunityID.value
                }
                await store.dispatch('Opportunities/deleteMarketingOpportunity',formData).
                then(()=>{
                    searchOpportunities();
                })
            }
        }
        const closeModal = () =>{
            propModalVisible.value = false;
        };
        const printCustomersList = () =>{
            

        };
        const showModalLoader1 = () =>{
            modal_loader1.value = "block";
        }
        const hideModalLoader1 = () =>{
            modal_loader1.value = "none";
        }
        const handleReset1 = () =>{
            contentModel.value = "";
            opportunityID.value = "";
        };
        const fetchTemplates = async() =>{
            let formData = {
                company: companyID.value,         
            }

            await store.dispatch("Crm_SMS_Templates/fetchTemplates", formData)
        };
        const fetchEmailTemplates = async() =>{
            let formData = {
                company: companyID.value,         
            }

            await store.dispatch("Crm_Email_Templates/fetchTemplates", formData)
        };
        const handleSelectedTemplate = async(option) =>{
            await store.dispatch('Crm_SMS_Templates/handleSelectedTemplate', option)
            contentModel.value = store.state.Crm_SMS_Templates.templateContent;
        };
        const clearSelectedTemplate = async() =>{
            await store.dispatch('Crm_SMS_Templates/updateState', {templateID: '', templateName: "", templateContent: ""});
        }
        const sendClientSMS = async() =>{
            if(opportunityID.value && contentModel.value){
                showModalLoader1();
                let formData = {
                    content: contentModel.value,
                    lead_opportunities: opportunityID.value,
                    company: companyID.value
                }
                await axios.post('api/v1/leads-general-sms/',formData).
                then((response)=>{
                    if(response.data.msg == "Success"){
                        toast.success("SMS Sent!")
                        closeModal1();
                        searchOpportunities();
                    }else{
                        toast.error(response.data.msg)
                    }
                })
                .catch((error)=>{
                    toast.error(error.message)
                })
                .finally(()=>{
                    hideModalLoader1();
                })
            }else if(leadID.value == ""){
                toast.error("No Lead Selected!!")
            }else if(contentModel.value == ""){
                toast.error("Cannot Send Blank SMS!!")
            }
            
        };
        const handleSelectedEmailTemplate = async(option) =>{
            await store.dispatch('Crm_Email_Templates/handleSelectedTemplate', option)
            emailTempID.value = store.state.Crm_Email_Templates.templateID;
        };
        const clearSelectedEmailTemplate = async() =>{
            await store.dispatch('Crm_Email_Templates/updateState', {templateID: '', templateName: "", templateContent: ""});
            emailTempID.value = '';
        }
        const sendClientEmail = async() =>{
            showModalLoader1();
            let formData = {
                template: emailTempID.value,
                opportunity: opportunityID.value,
                company: companyID.value
            }
            await axios.post('api/v1/leads-general-email/',formData).
            then((response)=>{
                if(response.data.msg == "Success"){
                    toast.success("Email Sent!")
                    closeModal1();
                    searchOpportunities();
                }else{
                    toast.error(response.data.msg)
                }
            })
            .catch((error)=>{
                toast.error(error.message)
            })
            .finally(()=>{
                hideModalLoader1();
            })
            
        };
        const dropdownOptions = ref([
            {label: 'SMS Selected Opportunity', action: 'send-sms', icon: 'fa-sms', colorClass: 'text-blue-600', rightName: 'Sending CRM SMS'},
            {label: 'Email Selected Opportunity', action: 'send-email', icon: 'fa-envelope', colorClass: 'text-indigo-600', rightName: 'Sending CRM Emails'},
        ]);
        const handleDynamicOption = async(option) =>{
            if(option == 'send-sms'){
                if(selectedIds.value.length == 0){
                    toast.error("Please Select An Opportunity To Send SMS")
                    return;
                }
                fetchTemplates();
                opportunityID.value = selectedIds.value;
                transModalVisible.value = true;
                
            }else if(option == 'send-email'){
                if(selectedIds.value.length == 0){
                    toast.error("Please Select An Opportunity To Send Email")
                    return;
                }
                fetchEmailTemplates();
                opportunityID.value = selectedIds.value;
                emailModalVisible.value = true;
            }
        };
        const closeModal1 = async() =>{
            transModalVisible.value = false;
            emailModalVisible.value = false;
            handleReset1();
        }
        onBeforeMount(()=>{
            searchOpportunities();
            fetchMarketingLeads();
        })
        return{
            title, searchOpportunities,resetFilters, addButtonLabel, searchFilters, tableColumns, oppsList,
            currentPage,propResults, propArrLen, propCount, pageCount, showNextBtn, showPreviousBtn,dropdownOptions,handleDynamicOption,
            loadPrev, loadNext, firstPage, lastPage, idField, actions, handleActionClick, propModalVisible, closeModal,
            submitButtonLabel, showModal, addNewOpportunity, showLoader, loader, hideLoader, modal_loader, modal_top, modal_left, modal_width,displayButtons,
            showModalLoader, hideModalLoader, saveOpportunity, formFields, handleSelectionChange, flex_basis,flex_basis_percentage,
            importLeads, removeOpportunity, removeOpportunitys, handleReset,printCustomersList,addingRight,removingRight,rightsModule,selectSearchQuantity,selectedValue,
            messageContent,modal_loader1,title1,showModalLoader1,hideModalLoader1,sendClientSMS,transModalVisible,emailModalVisible,title2,
            closeModal1,contentModel,textareaRef,leadPlaceholders,selectedPlaceholder,insertPlaceholder,templateArr,dropdownWidth,
            handleSelectedTemplate,clearSelectedTemplate,handleSelectedEmailTemplate,clearSelectedEmailTemplate,emailTempArr,sendClientEmail
        }
    }
};
</script>